import React, { useState } from 'react';
import qs from 'qs';
import {
  Button,
  InputBase,
  FormHelperText,
  LinearProgress,
  FormControl,
  Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useToast } from '~/_base/context/toastContext';
import validateEmail from '../../_base/functions/validateEmail';
import api from '~/_base/constants/api';

export default function FindYourAPEUrl() {
  const classes = useStyles();
  const { errorToast, successToast } = useToast();
  const queryString = (document.location.search || '').slice(1);
  const params = qs.parse(queryString);
  const initialEmail = params['email'] || '';
  const [email, setEmail] = useState(initialEmail as string);
  const [emailValid, setEmailValid] = useState(validate(initialEmail as string));
  const [pending, setPending] = useState(false);

  function handleEmailChange(event: React.SyntheticEvent) {
    setEmailValid(true);
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    setEmail(target.value);
  }

  function handleKeyUp(event: React.KeyboardEvent) {
    const valid = validate(email);
    if (event.key === 'Enter') {
      setEmailValid(valid);
      valid && checkServersByEmail();
    }
  }

  function validate(value: string) {
    return !value ? true : validateEmail(value);
  }

  async function checkServersByEmail() {
    if (!emailValid) return;
    try {
      setPending(true);
      const payload = { email, device: 'Web Browser' };
      const json = await api.serversByEmail.request(JSON.stringify(payload));
      setPending(false);
      if (json.matches > 0) {
        successToast(
          `The magic link is on its way to ${email}, just click to log in.`
        );
      } else if (json.matches === 0) {
        errorToast(
          `Sorry, we couldn't find any Damstra Forms accounts for that email address.`
        );
      }
    } catch (err) {
      setPending(false);
      errorToast((err as Error).message);
    }
  }

  return (
    <React.Fragment>
      <Typography variant="h1">Find your Damstra Forms URL</Typography>
      <Typography variant="body1" className={classes.bodyText}>
        We’ll send you an email to confirm your address with a magic link to
        Damstra Forms that will sign you in instantly.
      </Typography>
      <FormControl variant="standard" fullWidth error={!emailValid}>
        <InputBase
          onBlur={e =>
            setEmailValid(validate((e.target as HTMLInputElement).value))
          }
          id="session_email"
          name="session[email]"
          value={email}
          type="email"
          onChange={handleEmailChange}
          onKeyUp={handleKeyUp}
          placeholder="Your email address"
        />
        {!emailValid && (
          <FormHelperText>Please enter a valid email address</FormHelperText>
        )}
        <Button
          className={classes.button}
          disabled={!email.length || pending}
          variant="contained"
          color="primary"
          onClick={checkServersByEmail}
        >
          Send Magic Link
          {pending && <LinearProgress className={classes.buttonProgress} />}
        </Button>
      </FormControl>
    </React.Fragment>
  );
}

const useStyles = makeStyles(theme => ({
  bodyText: {
    margin: theme.spacing(3, 0),
  },
  buttonProgress: {
    width: '100%',
    position: 'absolute',
    bottom: '0',
  },
  button: { maxWidth: '14rem', marginTop: theme.spacing(1) },
}));
